/* BSFA Account dropdown — opens a small panel instead of navigating */
(function () {
  'use strict';
  function close(el){ el.classList.remove('is-open'); var t=el.querySelector('.bsfa-acct__toggle'); if(t) t.setAttribute('aria-expanded','false'); }
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('.bsfa-acct__toggle');
    if (toggle) {
      var wrap = toggle.closest('.bsfa-acct');
      if (wrap) {
        e.preventDefault();
        var open = !wrap.classList.contains('is-open');
        document.querySelectorAll('.bsfa-acct.is-open').forEach(close);
        if (open) { wrap.classList.add('is-open'); toggle.setAttribute('aria-expanded','true'); }
        return;
      }
    }
    if (!(e.target.closest && e.target.closest('.bsfa-acct__panel'))) {
      document.querySelectorAll('.bsfa-acct.is-open').forEach(close);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.bsfa-acct.is-open').forEach(close);
  });
})();
